import SectionHeading from './SectionHeading';
import { rankList } from '@/mocks/rankList';

const trendMeta: Record<string, { icon: string; className: string; label: string }> = {
  up: { icon: 'ri-arrow-up-line', className: 'text-accent-600', label: '热度上升' },
  down: { icon: 'ri-arrow-down-line', className: 'text-secondary-600', label: '热度回落' },
  flat: { icon: 'ri-subtract-line', className: 'text-foreground-500', label: '热度持平' },
};

export default function RankBoard() {
  const maxHeat = Math.max(...rankList.map((item) => Number(item.heat)));

  return (
    <section id="rank" className="scroll-mt-16 bg-background-100 py-14 md:py-20 border-t border-background-200/70">
      <div className="px-4 md:px-8">
        <SectionHeading
          icon="ri-bar-chart-2-line"
          eyebrow="热度榜单"
          title="榜单：当前综合热度排名前十"
          desc="榜单综合更新节奏、条目完整度与浏览关注度生成，用来快速了解近期更受关注的热播剧与电影。热度值仅作相对比较，排名会随更新情况变化。"
          tone="accent"
        />

        <div className="mt-8 grid grid-cols-1 lg:grid-cols-2 gap-3 md:gap-4">
          {rankList.map((item) => {
            const trend = trendMeta[item.trend];
            const width = `${Math.round((Number(item.heat) / maxHeat) * 100)}%`;
            return (
              <div
                key={item.id}
                className="flex items-center gap-4 px-4 py-3 rounded-lg bg-background-50 border border-background-200 transition-colors hover:border-primary-300"
              >
                <span
                  className={`flex items-center justify-center w-9 h-9 shrink-0 rounded-md font-heading text-sm font-black ${
                    item.rank <= 3 ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-700'
                  }`}
                >
                  {item.rank}
                </span>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center justify-between gap-2">
                    <h3 className="font-heading text-sm font-bold text-foreground-950 truncate">{item.title}</h3>
                    <span className="shrink-0 px-2 py-0.5 text-xs rounded-md bg-secondary-100 text-secondary-900">
                      {item.type}
                    </span>
                  </div>
                  <div className="mt-2 flex items-center gap-3">
                    <div className="h-1.5 flex-1 rounded-full bg-background-200 overflow-hidden">
                      <div className="h-full rounded-full bg-primary-500" style={{ width }} />
                    </div>
                    <span className="flex items-center gap-0.5 text-xs text-foreground-600">
                      <i className={`${trend.icon} ${trend.className}`} aria-hidden="true"></i>
                      {item.heat}
                    </span>
                    <span className="sr-only">{trend.label}</span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}